import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations'
import SingleButton from "../components/SingleButton";
import HistoryList from "./HistoryList";
import HistoryElementComparator from "./HistoryElementComparator";


function HistoryListPopup(
    {
        onClose,
        loadHistoryList,
        loadHistoryElement,
        propertyTransformer,
        customParamTransformer
    }) {

    const [historyList, setHistoryList] = useState(null);
    const [selectedElem, setSelectedElem] = useState(null);
    const [selectedElemLoaded, setSelectedElemLoaded] = useState(null);

    useEffect(() => {
        loadHistoryList().then(resp => setHistoryList(resp))
        // eslint-disable-next-line
    }, [])

    const clearSelectedElem = () => {
        setSelectedElem(null);
        setSelectedElemLoaded(null);
    }
    const selectElem = (elem) => {
        setSelectedElem(elem);
        loadHistoryElement(elem.identity).then((resp) => setSelectedElemLoaded(resp)).catch((e) => {
            console.error(e);
            clearSelectedElem();
        })
    }

    return (
        <Dialog
            open
            title={Tr('change_history')}
            titleCentered
            maxWidth='lg'
            onClose={onClose}
            dialogActions={<SingleButton
                justify='flex-end'
                label={Tr('close')}
                onClick={onClose}/>}
        >
            {
                !selectedElemLoaded ? <HistoryList historyList={historyList} selectedElem={selectedElem} selectElem={selectElem}/> :
                    <HistoryElementComparator clearSelectedElem={clearSelectedElem} selectedElem={selectedElem} selectedElemLoaded={selectedElemLoaded}
                                              propertyTransformer={propertyTransformer} customParamTransformer={customParamTransformer}/>

            }
        </Dialog>
    )
}

HistoryListPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    loadHistoryList: PropTypes.func.isRequired,
    loadHistoryElement: PropTypes.func.isRequired,
    propertyTransformer: PropTypes.object.isRequired,
    customParamTransformer: PropTypes.object
}

export default HistoryListPopup;
